import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Profile } from '../models/interfaces/profile.interface';
import { ProfileService } from '../services/profile.service';

@Injectable({
  providedIn: 'root',
})
export class UserFormResolver implements Resolve<Profile[]> {
  constructor(private service: ProfileService) {}

  resolve(): Promise<Profile[]> {
    const profilePromise = new Promise<Profile[]>(async (resolve, reject) => {
      try {
        const profileLocal: Profile[] = [];
        const profiles = await this.service.getAll().toPromise();

        profiles.forEach((e: Profile) => {
          if (typeof e.id === 'string') {
            profileLocal?.push(e);
          }
        });

        profileLocal?.sort((a, b) => a.name.localeCompare(b.name));
        resolve(profileLocal!);
      } catch (error) {
        console.log(error);
        reject([]);
      }
    });
    return profilePromise;
  }
}
